import styled from "styled-components";
import { MEDIA_Q } from "../../../../config/constants/css";

export const StyledDialerDashboard = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;
`;

export const StyledDialerDashboardItems = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: 1fr;

  ${MEDIA_Q.SM} {
    grid-template-columns: 1fr 1fr;
  }
  ${MEDIA_Q.LG} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledDialerDashboardItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  padding: 14px;
`;

export const StyledBottomCta = styled.div`
  position: absolute;
  right: 40px;
  bottom: 50px;
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
`;
